/* Keep offscreen PDP media out of the legacy loader's repeated geometry scans.
 * Reuse its existing responsive-image, background and app-include plugins. */
(function () {
  var lazy = window.lazySizesT4;
  if (!lazy || !window.__drexeyObserveLazyMedia) return;
  var lazyClass = lazy.cfg.lazyClass;
  var selector = '.' + lazyClass;
  var pending = new Set();
  var observer;

  function unveil(element) {
    if (!pending.has(element)) return;
    // Do not hand an unfinished placeholder to the legacy image loader.
    if (element.tagName === 'IMG' && element.getAttribute('src') && !element.complete) {
      element.addEventListener('load', function () { unveil(element); }, { once: true });
      element.addEventListener('error', function () { unveil(element); }, { once: true });
      return;
    }
    pending.delete(element);
    observer.unobserve(element);
    lazy.loader.unveil(element);
  }

  function register(element) {
    if (!element || element.nodeType !== 1 || !element.matches(selector)) return;
    if (pending.has(element) || element._lazyRace) return;
    pending.add(element);
    element.classList.remove(lazyClass);
    observer.observe(element);
  }

  function registerTree(root) {
    register(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(register);
  }

  try {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) unveil(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    registerTree(document);
    // Observe additions only: gallery/style mutations no longer trigger a full
    // offscreen image scan. Existing loader plugins still handle source updates.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(registerTree);
        record.removedNodes.forEach(function (root) {
          pending.forEach(function (element) {
            if (!element.isConnected && (root === element || (root.contains && root.contains(element)))) {
              observer.unobserve(element);
              pending.delete(element);
              element.classList.add(lazyClass);
            }
          });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (error) {
    if (observer) observer.disconnect();
    pending.forEach(function (element) { element.classList.add(lazyClass); });
    pending.clear();
  }
  // Active/nearby media retain the theme's normal loader and resize behavior.
  lazy.init();
})();
